import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const acceptRejectRequest = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunctionPut(data,apiConstants.TICKET.ACCEPT_REJECT_REQUEST)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default acceptRejectRequest;